(function () {
  document.querySelectorAll('.dp-gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-gallery-target'));
      if (!target) return;
      target.src = btn.getAttribute('data-full-src');
      target.alt = btn.getAttribute('data-alt') || '';
      document.querySelectorAll('.dp-gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  document.querySelectorAll('[data-dp-variant-picker]').forEach(function (picker) {
    var productId = picker.getAttribute('data-product-id');
    var jsonEl = document.querySelector('[data-dp-variants-json="' + productId + '"]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var selects = Array.from(picker.querySelectorAll('.dp-variant-select'));
    var form = picker.closest('form');
    var hiddenInput = form ? form.querySelector('[data-dp-variant-id]') : null;
    var submitBtn = form ? form.querySelector('.dp-add-to-cart') : null;
    var galleryMain = document.querySelector('.dp-gallery__main-image');

    // Antes de nada, deshabilita cada <option> que no forme parte de NINGUNA
    // variante disponible, sea cual sea el resto de la selección (imposibles de raíz).
    selects.forEach(function (select, index) {
      Array.from(select.options).forEach(function (option) {
        if (!option.value) return; // opción vacía tipo "Elige una opción"
        var existsAtAll = variants.some(function (v) {
          return v.options[index] === option.value;
        });
        if (!existsAtAll) {
          option.disabled = true;
        }
      });
    });

    function refreshOptionAvailability() {
      var selectedValues = selects.map(function (s) { return s.value; });

      selects.forEach(function (select, index) {
        Array.from(select.options).forEach(function (option) {
          if (!option.value) return;

          var testValues = selectedValues.slice();
          testValues[index] = option.value;

          var matches = variants.some(function (v) {
            return v.options.every(function (opt, i) {
              return testValues[i] === '' || opt === testValues[i];
            });
          });

          option.disabled = !matches;
        });
      });
    }

    function updateVariant() {
      refreshOptionAvailability();

      var selectedValues = selects.map(function (s) { return s.value; });
      if (selectedValues.indexOf('') !== -1) return;

      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedValues[i]; });
      });

      if (!match) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'No disponible';
        }
        if (hiddenInput) hiddenInput.value = '';
        return;
      }

      if (hiddenInput) hiddenInput.value = match.id;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Añadir al carrito' : 'Agotado';
      }

      if (galleryMain && match.featured_image && match.featured_image.src) {
  galleryMain.src = match.featured_image.src;
  galleryMain.setAttribute('data-zoom-src', match.featured_image.src);
  galleryMain.alt = match.featured_image.alt || '';
  document.querySelectorAll('.dp-gallery__thumb').forEach(function (b) {
    b.classList.toggle('is-active', b.getAttribute('data-full-src') === match.featured_image.src);
  });
}
    }

    refreshOptionAvailability();
    selects.forEach(function (select) { select.addEventListener('change', updateVariant); });
  });

  // Interceptar el envío del formulario de compra para hacerlo por AJAX
  document.querySelectorAll('.dp-product-top__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.dp-add-to-cart');
      var variantIdInput = form.querySelector('[data-dp-variant-id]');
      var qtyInput = form.querySelector('[data-qty-input]');
      if (!variantIdInput || !variantIdInput.value) return;

      var variantId = variantIdInput.value;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Añadiendo...';
      }

      var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      evt.action = 'add';
      evt.context = 'product';
      evt.lines = [{ merchandiseId: variantId, quantity: qty }];

      var resolvePromise, rejectPromise;
      evt.promise = new Promise(function (resolve, reject) {
        resolvePromise = resolve;
        rejectPromise = reject;
      });
      document.dispatchEvent(evt);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo añadir');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          resolvePromise({ cart: cart });
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        })
        .catch(function (err) {
          document.dispatchEvent(new CustomEvent('shopify:cart:error', {
            bubbles: true,
            detail: { error: err.message, code: 'SERVICE_UNAVAILABLE' }
          }));
          rejectPromise(err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Error, reintenta';
            setTimeout(function () { submitBtn.textContent = originalText; }, 1800);
          }
        });
    });
  });
  document.querySelectorAll('[data-dp-buy-now]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var form = btn.closest('.dp-product-top').querySelector('.dp-product-top__form');
    if (!form) return;
    var variantIdInput = form.querySelector('[data-dp-variant-id]');
    var qtyInput = form.querySelector('[data-qty-input]');
    if (!variantIdInput || !variantIdInput.value) return;

    var variantId = variantIdInput.value;
    var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    var originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Procesando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('No se pudo añadir');
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Error, reintenta';
        setTimeout(function () { btn.textContent = originalText; }, 1800);
      });
  });
});
})();